export default ($axios) => ({
    $axios,

    async fetch({
        query,
        params = '',
    }) {
        return await $axios.get(`/clients${query}${params}`)
    },

    async fetchById(id) {
        return await $axios.get(`/clients/${id}`)
    },

    async fetchHistoryCommunication(id) {
        return await $axios.get(`/clients/${id}/history_communication/`)
    },

    async fetchCommentsById(id) {
        return await $axios.get(`/clients/${id}/comments_ratings`)
    },

    async markClientAsRead({
        id,
        is_read,
    }) {
        return await $axios.put(`/clients/${id}/read`, {
            is_read,
        })
    },

    async statistics() {
        return await $axios.get('/statistic/clients')
    },

    async create(client) {
        return await $axios.post('/clients', client)
    },

    async updateById(id, form) {
        return await $axios.put(`/clients/${id}`, form)
    },

    async updateAddressesById(id, address) {
        return await $axios.put(`/clients/addresses/${id}`, address)
    },

    async updateImageById(id, formData) {
        return await $axios.post(`/clients/${id}/image`, formData)
    },

    async remove(id) {
        return await $axios.delete(`/clients/${id}`)
    },

    async addSchedule(form) {
        return await $axios.post('/schedule/company', form)
    },

    async addScheduleByDay(form) {
        const { service_id } = form
        const finalForm = form

        delete finalForm.days
        delete finalForm.service_id

        return await $axios.post(`/schedule/company/services/${service_id}`, finalForm)
    },

    async fetchSchedule({
        year,
        month,
        office_id,
    }) {
        const localYear = year ? `year=${year}&` : ''
        const localMonth = month ? `month=${month}&` : ''
        const localOfficeId = office_id ? `office_id=${office_id}&` : ''

        return await $axios.get(`/schedule/company/services?${localOfficeId}${localYear}${localMonth}`)
    },

    async fetchScheduleById({
        year,
        month,
        service_id,
    }) {
        const localYear = year ? `year=${year}&` : ''
        const localMonth = month ? `month=${month}&` : ''

        return await $axios.get(
            `/schedule/company/services/${service_id}?${localYear}${localMonth}`,
        )
    },

    async deleteScheduleById(id) {
        return await $axios.delete(`/schedule/company/schedule/${id}`)
    },

    async deleteScheduleAll({
        year,
        month,
        office_id,
    }) {
        const localYear = year ? `year=${year}&` : ''
        const localMonth = month ? `month=${month}&` : ''
        const localOfficeId = office_id ? `office_id=${office_id}&` : ''

        return await $axios.delete(`/schedule/company?${localOfficeId}${localYear}${localMonth}`)
    },

    async deleteScheduleAllByServive({
        year,
        month,
        service_id,
    }) {
        const localYear = year ? `year=${year}&` : ''
        const localMonth = month ? `month=${month}&` : ''

        return await $axios.delete(
            `/schedule/company/services/${service_id}?${localYear}${localMonth}`,
        )
    },

    async editSchedule(id, form) {
        return await $axios.put(`/schedule/company/schedule/${id}`, form)
    },
})
